'use strict';

angular.module('harriApp')
    .factory('hUser', ['localize', '$state', 'httpHelper', 'asyncGlobalHandler', 'hEvent', 'hUserLocation', 'userMedia', '$q', '$rootScope', '$cacheFactory', '$timeout',
        function (localize, $state, httpHelper, asyncGlobalHandler, hEvent, hUserLocation, userMedia, $q, $rootScope, $cacheFactory, $timeout) {

            var afterLoginSuccessfullyLink = null;

            var isForceJobTemplatesEnabled = true;


            const getUserLoggedInInfo = () => {
                // Shared state across apps (when moving from workspace to this app)
                let sharedState = HStorageManager.get({
                    storageLevel: HStorageManager.StorageLevels.SESSION,
                    key: 'shared_state'
                });

                if (sharedState) {

                    if (sharedState['user_info']) {
                        const defer = $q.defer();
                        console.log("Passed cross apps (user info):", sharedState['user_info']);
                        defer.resolve(sharedState['user_info']);
                        delete sharedState['user_info'];
                        HStorageManager.put({
                            storageLevel: HStorageManager.StorageLevels.SESSION,
                            key: 'shared_state',
                            value: sharedState
                        });
                        return defer.promise;
                    }
                }

                return UserAPI.getLoggedInUserInfo();
            }

            //check if user has access to a service
            var isServiceEnabled = function (service) {

                return user.data.user && user.data.user.services
                    && (user.data.user.services.indexOf(service) > -1)
            };

            let _emitter;
            let userBrandsIdentifier;
            //the saved user object
            var user = {
                isLoggedIn: function () {
                    return !!user?.data?.user?.id;
                },
                EVENTS: {
                    USER_BRANDS_LIST_UPDATED: 'USER_BRANDS_LIST_UPDATED',
                },
                data: {
                    user: {},
                    getUserSlugLink: function () {
                        var userSlug = user.data.user.slug;
                        var websiteUrl = $state.href('homepage', {}, {absolute: true});

                        return websiteUrl + userSlug;
                    },
                    mfaStatus: null,
                },
                isImpersonate: function () {
                    return user.data && user.data.user && user.data.user.impersonate;
                },
                /**
                 * check if the user is employer or not
                 *
                 * @returns {boolean}
                 */
                isEmployer: function () {
                    return user.data && user.data.user && user.data.user.hasOwnProperty('user_employer') && user.data.user.user_employer === true;
                },
                init: function() {
                    var defer = $q.defer();

                    getUserLoggedInInfo()
                        .then(function(res) {
                            if (Utils.maintenancePageCheck($state)) {
                                return;
                            }

                            user.updateUserData(res);
                            defer.resolve(res);
                        }, function(err) {
                            console.error(err);
                            if (
                                err &&
                                err.data &&
                                err.data.errors &&
                                err.data.errors[0] &&
                                !(err.data.errors[0].status == 400 && err.data.errors[0].code === 'SYSTEM_MAINTENANCE_MODE')
                            ) {
                                if (Utils.maintenancePageCheck($state)) {
                                    return;
                                }
                            }

                            if (err && err.status !== -1) {
                                if (
                                    err.data &&
                                    err.data.errors &&
                                    err.data.errors[0] &&
                                    err.data.errors[0].status == 400 &&
                                    err.data.errors[0].code === 'SYSTEM_MAINTENANCE_MODE'
                                ) {
                                    if ($state.current.name != 'maintenance') {
                                        HStorageManager.put({
                                            storageLevel: HStorageManager.StorageLevels.LOCAL_STORAGE,
                                            key: 'pre_maintenance',
                                            value: location.href
                                        });
                                        hRedirect("maintenance");
                                    }

                                    return;
                                }
                            }
                            user.logout();
                            defer.resolve(err);
                        });

                    return defer.promise;
                },

                getFullUserData: function() {
                    var defer = $q.defer();

                    getUserLoggedInInfo()
                        .then(function(res) {
                            if (Utils.maintenancePageCheck($state)) {
                                return;
                            }

                            user.updateUserData(res)
                                .then(function (userData) {
                                    defer.resolve(userData);
                                })
                                .catch(function (err) {
                                    defer.reject(err);
                                })
                        }, function(err) {
                            console.error(err);
                            if (
                                err &&
                                err.data &&
                                err.data.errors &&
                                err.data.errors[0] &&
                                !(err.data.errors[0].status == 400 && err.data.errors[0].code === 'SYSTEM_MAINTENANCE_MODE')
                            ) {
                                if (Utils.maintenancePageCheck($state)) {
                                    return;
                                }
                            }

                            if (err && err.status !== -1) {
                                if (
                                    err.data &&
                                    err.data.errors &&
                                    err.data.errors[0] &&
                                    err.data.errors[0].status == 400 &&
                                    err.data.errors[0].code === 'SYSTEM_MAINTENANCE_MODE') {
                                    if ($state.current.name != 'maintenance') {
                                        HStorageManager.put({
                                            storageLevel: HStorageManager.StorageLevels.LOCAL_STORAGE,
                                            key: 'pre_maintenance',
                                            value: location.href
                                        });
                                        hRedirect("maintenance");
                                    }

                                    return;
                                }
                            }
                            user.logout();
                            defer.resolve(err);
                        });

                    return defer.promise;
                },
                //Used to refresh user data
                refresh: function () {
                    var defer = $q.defer();

                    getUserLoggedInInfo()
                        .then(function(res) {

                            if (Utils.maintenancePageCheck($state)) {
                                return;
                            }

                            user.data.user = angular.extend({}, user.data.user, res);

                            user.getUserPolicy()
                                .then(function() {
                                    defer.resolve();
                                })
                        }, function(err) {
                            console.error(err);
                            if (
                                err &&
                                err.data &&
                                err.data.errors &&
                                err.data.errors[0] &&
                                !(err.data.errors[0].status == 400 && err.data.errors[0].code === 'SYSTEM_MAINTENANCE_MODE')
                            ) {
                                if (Utils.maintenancePageCheck($state)) {
                                    return;
                                }
                            }
                            //in case of internet disconnection keep him logged in
                            if(err && err.status !== -1) {
                                if (err.data && err.status === 401) {
                                    user.logout();
                                    defer.reject(err);
                                }
                                else if (
                                    err.data &&
                                    err.data.errors &&
                                    err.data.errors[0] &&
                                    err.data.errors[0].status == 400 &&
                                    err.data.errors[0].code === 'SYSTEM_MAINTENANCE_MODE'
                                ) {
                                    if ($state.current.name != 'maintenance') {
                                        HStorageManager.put({
                                            storageLevel: HStorageManager.StorageLevels.LOCAL_STORAGE,
                                            key: 'pre_maintenance',
                                            value: location.href
                                        });
                                        hRedirect("maintenance");
                                    }
                                    return;
                                }
                                else {
                                    defer.resolve();
                                }

                            } else {
                                defer.resolve();
                            }
                        });

                    return defer.promise;
                },
                redirectToPlatformWithPermission: function (notifyBrandsList) {
                    var defer = $q.defer();

                    if (!user.isTopLevelContext()) {
                        const userContext = user.getUserContext();
                        const updateUserPolicies = function () {
                            UserAPI.getUserPolicies(userContext.brand_id)
                                .then((userPolicies) => {
                                    user.data.user = {...user.data.user, ...userPolicies};
                                    $rootScope.$broadcast('user_updated', user.EVENTS.USER_BRANDS_LIST_UPDATED);
                                    defer.resolve();
                                })
                                .catch((err) => {
                                    console.error("Couldn't load user polices", err);
                                    defer.reject("Couldn't load user polices");
                                });
                        }

                        if (userContext?.brand_id) {
                            if (user.isEmployer()) {
                                user.updateUsersBrandsList(notifyBrandsList)
                                    .then(() => {
                                        updateUserPolicies();
                                    })
                                    .catch((err) => console.error(err));
                            } else {
                                updateUserPolicies();
                            }
                        } else {
                            defer.resolve();
                        }
                    } else {
                        defer.resolve();
                    }

                    return defer.promise;
                },
                getUserPolicy: function (notifyBrandsList) {
                    var defer = $q.defer();

                    if (user.isEmployer()) {

                        user.redirectToPlatformWithPermission(notifyBrandsList)
                            .then(function () {
                                if (user.isTopLevelContext()) {
                                    delete(user.data.user.services);
                                }

                                defer.resolve();
                            })
                            .catch(function (reason) {
                                console.error(reason);
                                defer.reject();
                            });
                    } else {
                        defer.resolve();
                    }

                    return defer.promise;
                },
                getUserImages: function () {
                    return userMedia.getUserBasicMedia();
                },

                /**
                 * Get device user location
                 *
                 * @returns {*}
                 */
                getUserDeviceLocation: function () {
                    return hUserLocation.getDeviceLocation();
                },
                getUserHighestBrandAccess: function () {
                    if (user.isTopLevelContext()) {
                        return user.getUserContext();
                    }
                    else {
                        return user.data.user.brands_list[0];
                    }
                },
                getEntryMode: function () {
                    return user.data.user.entry_mode
                },
                //User Context related
                clearUserContext: function() {
                    HStorageManager.put({
                        storageLevel: HStorageManager.StorageLevels.SESSION,
                        key: 'userContext',
                        value: 'HMAP'
                    });
                    HStorageManager.remove({
                        storageLevel: HStorageManager.StorageLevels.COOKIES,
                        key: 'userContext'
                    });
                    user.triggerContextUpdated();
                    if (user.isLoggedIn() && user.isEmployer()) {
                        user.updateUsersBrandsList();
                    }
                },
                isLoggedInWithMagicToken: function () {
                    return HStorageManager.get({
                        storageLevel: HStorageManager.StorageLevels.SESSION,
                        key: 'magicLinkToken'
                    });
                },
                setUserContext: function (userContext) {
                    HStorageManager.put({
                        storageLevel: HStorageManager.StorageLevels.SESSION,
                        key: 'userContext',
                        value: userContext
                    });
                    HStorageManager.put({
                        storageLevel: HStorageManager.StorageLevels.COOKIES,
                        key: 'userContext',
                        value: userContext
                    });
                    user.triggerContextUpdated();
                    return user.getUserPolicy(true);
                },
                getUserContext: function () {
                    if(HStorageManager.get({
                        storageLevel: HStorageManager.StorageLevels.SESSION,
                        key: 'userContext'
                    }) === "HMAP") {
                        return user.data.user.entry_mode;
                    } else if (!_.isEmpty(HStorageManager.get({
                            storageLevel: HStorageManager.StorageLevels.SESSION,
                            key: 'userContext'
                        }))
                        && HStorageManager.get({
                            storageLevel: HStorageManager.StorageLevels.SESSION,
                            key: 'userContext'
                        }) !== "null"
                        && HStorageManager.get({
                            storageLevel: HStorageManager.StorageLevels.SESSION,
                            key: 'userContext'
                        }) !== "undefined") {
                        return HStorageManager.get({
                            storageLevel: HStorageManager.StorageLevels.SESSION,
                            key: 'userContext'
                        });
                    } else if (HStorageManager.get({
                        storageLevel: HStorageManager.StorageLevels.COOKIES,
                        key: 'userContext'
                    })) {
                        return HStorageManager.get({
                            storageLevel: HStorageManager.StorageLevels.COOKIES,
                            key: 'userContext'
                        });
                    }

                    // Make it work with user without brands
                    return user.data.user.entry_mode || {};
                },
                onContextUpdated: function (handler) {
                    return user.on("context-updated", handler);
                },
                triggerContextUpdated: function (handler) {
                    return _emitter.trigger("context-updated", handler);
                },
                onBrandsListUpdated: function (handler) {
                    return user.on("brands-list-updated", handler);
                },
                triggerBrandsListUpdated: function (handler) {
                    return _emitter.trigger("brands-list-updated", handler);
                },
                isHighestParent: function (brandId) {
                    const brandsList = user.data.user.brands_list;
                    const brand = brandsList?.find(brand => brand.id === brandId);

                    if (brand) {
                        return brand.id === brand.group_id;
                    }

                    console.error('cannot find brand', brandId, brandsList);
                },
                isHMAPUser: function() {
                    var entryMode = user.data.user.entry_mode;
                    return entryMode && entryMode.brand_type && entryMode.brand_type.indexOf("GP") > -1;
                },
                isTopLevelContext: function() {
                    if(!user.isEmployer()) {
                        return false;
                    }

                    var entryMode = user.getUserContext();

                    if(!entryMode || !entryMode.brand_type) {
                        return false;
                    }

                    return entryMode.brand_type.indexOf("GP") > -1;
                },
                getUserAccessType: function () {
                    var user_context = this.getUserContext();
                    return user_context.access_type;
                },
                getHighestBrandIdWithAccess: function () {
                    return user.data.user.brands_list?.length === 1 ? user.data.user.brands_list[0].id : user.getUserContext().brand_id;
                },
                getActiveBrandIdWithAccess: function () {
                    const activeBrandId = user.getActiveBrandId();

                    if (user.data.user.brands_list?.length) {
                        return user.data.user.brands_list.some(brand => activeBrandId === brand.id) ? activeBrandId : user.data.user.brands_list[0].id;
                    }

                    return activeBrandId;
                },
                isEnterpriseContext: function(){
                    var user_context = this.getUserContext();
                    return user_context.brand_type === "enterprise";
                },
                isBrandContext: function(){
                    var user_context = this.getUserContext();
                    return user_context.brand_type === "brand";
                },
                isHallAndWoodhouseExternalAuth: function() {
                    var externalAuth = user.data.user.external_auth;
                    return externalAuth && externalAuth.source && externalAuth.source == "HALL_AND_WOOD_HOUSE";
                },
                isRadissonExternalAuth: function() {
                    var radissonExternalAuth = user.data.user.external_auth;
                    return radissonExternalAuth && radissonExternalAuth.source && radissonExternalAuth.source == "RADISSON";
                },
                isMCDExternalAuth: function() {
                    var externalAuth = user.data.user.external_auth;
                    return externalAuth && externalAuth.source == "MCD";
                },
                isSubwayExternalAuth: function() {
                    var externalAuth = user.data.user.external_auth;
                    return externalAuth && externalAuth.source && externalAuth.source == "SUBWAY";
                },
                isMcdUKExternalAuth: function () {
                    return user.data.user.external_auth?.source === "MCD_UK";
                },
                getUserLocation: function () {
                    return hUserLocation.getLocation();
                },
                setUserPermission: function (result) {
                    var sbml_child_permissions = {};
                    /* find permission object from code for each permission set */
                    for (var permission in result) {
                        var brands = result[permission];
                        for (var brand in brands) {
                            sbml_child_permissions[brands[brand].id] = {
                                brand: brands[brand],
                                permission: permission
                            };
                        }
                    }
                    user.data.user.sbml_child_permissions = sbml_child_permissions;
                },
                updateUserPermission: function () {
                    SettingsAPI.getUserPermissions().then(function (result) {
                        /* load brands and permissions */
                        user.setUserPermission(result);
                    });
                },
                updateUsersBrandsList: function (notifyBrandsList) {
                    var defer = $q.defer();

                    var entryMode = user.getUserContext();
                    if (entryMode && entryMode.brand_id) {
                        if (userBrandsIdentifier === user.getUserBrandsIdentifier()) {
                            if(notifyBrandsList) {
                                user.triggerBrandsListUpdated();
                            }
                            defer.resolve();
                            return defer.promise;
                        }

                        BrandAPI.userBrandsByGroupId(user.getUserContext().brand_id, true)
                            .then(function (brandsList) {
                                user.data.user.brands_list = brandsList;

                                isForceJobTemplatesEnabled = true;

                                for (var i in brandsList) {
                                    if (['enterprise', 'agency', 'sbml'].indexOf(brandsList[i].type) > -1) {
                                        isForceJobTemplatesEnabled = brandsList[i].services.indexOf("FORCED_JOB_TEMPLATE") > -1;
                                    }
                                }

                                if (userBrandsIdentifier !== user.getUserBrandsIdentifier()) {
                                    userBrandsIdentifier = user.getUserBrandsIdentifier();
                                    user.triggerBrandsListUpdated();
                                }
                                defer.resolve();
                                $rootScope.$broadcast('user_updated', user.EVENTS.USER_BRANDS_LIST_UPDATED);
                            })
                            .catch(function (err) {
                                console.error(err);
                                defer.reject(err);
                            });
                    }
                    else {
                        defer.resolve();
                    }

                    return defer.promise;
                },
                updateUserData: function (data) {
                    var defer = $q.defer();

                    user.data = user.data || {};

                    /* keep some attributes  to not load it again */
                    data.brands_list = user.data.user.brands_list;
                    data.sbml_child_permissions = user.data.user.sbml_child_permissions;

                    //Update the data object
                    user.data.user = data;

                    //Call to identify the logged-in user
                    hEvent.identify(user.data.user);

                    var promises = {};
                    /* load brands list and save it in user */
                    //the entry mode is not availbe on first signup so we will pass
                    if (user.data.user.user_employer && !user.data.user.brands_list) {
                        promises['updateUsersBrandsList'] = user.updateUsersBrandsList();
                    }

                    /* sbml child user permission*/
                    if (user.isSBMLChild() && !user.data.user.sbml_child_permissions) {
                        promises['updateUserPermission'] = user.updateUserPermission();
                    }

                    $q.all(promises)
                        .then(function () {
                            defer.resolve(user.data.user);
                        })
                        .catch(function (err) {
                            defer.reject(err);
                        });

                    $rootScope.$broadcast('user_updated', user.EVENTS.USER_BRANDS_LIST_UPDATED);
                    return defer.promise;
                },
                login: function (response) {

                    if (user.isLoggedIn()) {
                        return;
                    }

                    user.clearUserContext();

                    if (response) {
                        user.updateUserData(response.data);
                    }

                    if (user.isLoggedIn()) {
                        HStorageManager.put({
                            storageLevel: HStorageManager.StorageLevels.LOCAL_STORAGE,
                            key: 'is_user',
                            value: true,
                            expiryDays: 30
                        });
                    }

                },
                reset: () => {
                    hEvent.reset();

                    //cleaning up
                    HStorageManager.remove({
                        storageLevel: HStorageManager.StorageLevels.COOKIES,
                        key: 'user'
                    });
                    HStorageManager.remove({
                        storageLevel: HStorageManager.StorageLevels.COOKIES,
                        key: 'userContext'
                    });
                    HStorageManager.remove({
                        storageLevel: HStorageManager.StorageLevels.COOKIES,
                        key: 'enterprise_id'
                    });
                    HStorageManager.remove({
                        storageLevel: HStorageManager.StorageLevels.COOKIES,
                        key: 'enterprise_slug'
                    });
                    HStorageManager.remove({
                        storageLevel: HStorageManager.StorageLevels.COOKIES,
                        key: 'brand_slug'
                    });
                    HStorageManager.remove({
                        storageLevel: HStorageManager.StorageLevels.COOKIES,
                        key: 'brand_id'
                    });
                    HStorageManager.remove({
                        storageLevel: HStorageManager.StorageLevels.COOKIES,
                        key: 'brand_name'
                    });

                    HStorageManager.remove({
                        storageLevel: HStorageManager.StorageLevels.COOKIES,
                        key: 'userRegistrationActiveForm'
                    });
                    HStorageManager.remove({
                        storageLevel: HStorageManager.StorageLevels.COOKIES,
                        key: 'new_user_user_candidate'
                    });
                    HStorageManager.remove({
                        storageLevel: HStorageManager.StorageLevels.COOKIES,
                        key: 'new_user_user_employer'
                    });

                    /* Dashboard Cookies
                     ========================================================*/
                    HStorageManager.remove({
                        storageLevel: HStorageManager.StorageLevels.COOKIES,
                        key: 'toggledBrandsCookie'
                    });
                    HStorageManager.remove({
                        storageLevel: HStorageManager.StorageLevels.COOKIES,
                        key: 'selectedJobFilterDashboard'
                    });

                    // Mobile Banner Cookies
                    HStorageManager.remove({
                        storageLevel: HStorageManager.StorageLevels.COOKIES,
                        key: 'mobile-banner-closed'
                    });

                    //Onboarding Dashboard
                    HStorageManager.remove({
                        storageLevel: HStorageManager.StorageLevels.COOKIES,
                        key: 'ONBOARDING_VIEW'
                    });

                    // carri step by step info component
                    HStorageManager.remove({
                        key: 'carriStepByStepHideen',
                        storageLevel: HStorageManager.StorageLevels.LOCAL_STORAGE
                    })

                    // cognito client id
                    HStorageManager.remove({
                        key: "client_id",
                        storageLevel: HStorageManager.StorageLevels.COOKIES
                    })

                    //Clear the user context in sessionSotrage
                    HStorageManager.remove({
                        storageLevel: HStorageManager.StorageLevels.SESSION,
                        key: 'userContext'
                    });

                    //clear $http cache
                    const $httpDefaultCache = $cacheFactory.get('$http');
                    $httpDefaultCache.removeAll();
                },
                //is part of the logout - directive logoutHref
                logout: function () {
                    var defer = $q.defer();
                    asyncGlobalHandler.watchPromise(defer.promise);
                    user.reset();

                    user.clearUserContext();
                    defer.resolve();
                    return defer.promise;

                },
                isSBMLAdmin: function () {
                    return user.data.user && user.data.user.sbml_type == 'sbml';
                },
                isSBMLChild: function () {
                    return user.data.user && user.data.user.sbml_type == 'sbml_child';
                },
                isEnterpriseBrandAdmin: function () {
                    if (user.data.user && user.data.user.brands_list) {
                        for (var i in user.data.user.brands_list) {
                            var brand = user.data.user.brands_list[i];
                            if (brand.id == user.getUserContext().brand_id && brand.type === 'enterprise') {
                                return true;
                            }
                        }
                    }

                    return false;
                },
                isBrandAdmin: function (brandId) {
                    return user.data.user.brands_list.findIndex(function (brand) {
                        return brand.id == brandId;
                    }) > -1;
                },
                setPrivacyShield: function (isEnabled) {
                    user.data.user.brand_private = isEnabled;
                },
                isPrivacyShieldOn: function () {
                    return user.data.user && user.data.user.brand_private;
                },
                isOnboardingServiceEnabled: function () {
                    return isServiceEnabled("ON_BOARDING");
                },
                isJobDistributorEnabled: function () {
                    return isServiceEnabled("JOB_DISTRIBUTOR");
                },
                isTeamSchedulingEnabled: function () {
                    return isServiceEnabled("TEAM_SCHEDULING");
                },
                isClockTimeAppEnabled: function () {
                    return isServiceEnabled("HARRI_CLOCK");
                },
                isPayrollServiceEnabled: function () {
                    return isServiceEnabled("PAYROLL");
                },
                isAutoLoadOfferTemplateServiceEnabled: function () {
                    return isServiceEnabled("AUTO_LOAD_OFFER_TEMPLATE");
                },
                isTTSDashboardEnabled: function () {
                    return isServiceEnabled("TTS_DASHBOARD");
                },
                isCustomLanesEnabled: function () {
                    return isServiceEnabled("CUSTOM_SWIMLANE");
                },
                isLPMEnabled: function () {
                    return isServiceEnabled("POS");
                },
                isHARAFRestrictionEnabled: function () {
                    return isServiceEnabled("HARAF_RESTRICTION");
                },
                isPreviewResumeEnabled: function () {
                    return isServiceEnabled("RESUME_PREVIEW");
                },
                isPayrollSyncEnabled: function () {
                    return isServiceEnabled("PAYROLL_SYNC");
                },
                isEVerifyServiceEnabled: function () {
                    return isServiceEnabled("E_VERIFY");
                },
                isAQAAFServiceEnabled: function () {
                    return isServiceEnabled("AQAAF");
                },
                isLMSServiceEnabled: function () {
                    return isServiceEnabled("LMS");
                },
                isForcedParentTemplatesServiceEnabled: function () {
                    return isForceJobTemplatesEnabled;
                },
                isInterviewV2ServiceEnabled: function () {
                    return isServiceEnabled("INTERVIEW_V2");
                },
                hasUnlimitedLocations: function () {
                    // Currently this is disabled for all
                    // For future use, it is implemented as an predicted service
                    return false;
                },
                isATREnabled: function(){
                    return isServiceEnabled("ATR");
                },
                hasSalesAccess: function () {
                    return (user.data && user.data.user && !(user.data.user.persona && user.data.user.persona.name === 'MANAGER_NO_SALES'));
                },
                addUserTempService: function (service) {
                    if (!user.data.user.services) {
                        user.data.user.services = [];
                    }

                    user.data.user.services.push(service);
                },
                clearUserTempServices: function () {
                    user.data.user.services = [];
                },
                addUserBrandTemp: function (brand) {
                    if (!user.data.user.brands_list) {
                        user.data.user.brands_list = [];
                    }
                    brand.temp = true;
                    user.data.user.brands_list.push(brand);
                },
                clearUserBrandTemp: function () {
                    for (var i = 0; i < user.data.user.brands_list.length; i++) {
                        var brand = user.data.user.brands_list[i];
                        if (brand.temp) {
                            ar_delete(user.data.user.brands_list, i);
                        }
                    }
                },
                getUserType: function () {
                    if (user.isSBMLAdmin()) {
                        return 'brand_manager';
                    }
                    else if (user.isSBMLChild()) {
                        return 'location_manager';
                    }
                    else if (user.isEmployer()) {
                        return 'employer';
                    }
                    else if (user.isLoggedIn()) {
                        return 'candidate';
                    }
                    else {
                        return 'guest';
                    }
                },
                getUser: function () {
                    return user.data.user;
                },
                canPostJob: function () {
                    if (!user.data.user || !user.data.user.user_employer) {
                        return false;
                    }

                    if (user.isSBMLChild()) {
                        if (user.data.user.sbml_child_permissions) {
                            for (var i in user.data.user.sbml_child_permissions) {
                                //check for the lowest level of permission
                                if (user.data.user.sbml_child_permissions[i].permission == SettingsAPI.SBML_USER_PERMISSIONS.CAN_POST.code ||
                                    user.data.user.sbml_child_permissions[i].permission == SettingsAPI.SBML_USER_PERMISSIONS.CAN_POST_TEMPLATE.code) {
                                    return true;
                                }
                            }
                            return false;
                        } else {
                            return false;
                        }
                    }

                    return true;
                },
                loginSuccessfully: function (data) {
                    var isTopLevel = data && data.entry_mode && data.entry_mode.brand_type && data.entry_mode.brand_type.indexOf("GP") > -1;
                    if(user.getLinkAfterLoginSuccessfully()){
                        $timeout(function(){
                            hRedirect( join_query_link(user.getLinkAfterLoginSuccessfully(), {'ref': window.referer}) );
                        });
                        return;
                    }

                    //keep the user in the same page if he wasn't redirected to login page
                    if ($state.current.name && ["registration.login","homepage.user.login", "qsr-login"].indexOf($state.current.name) === -1) {
                        $state.reload();
                    }

                    //make sure to clear the usercontext after login
                    user.clearUserContext();

                    var redirectUri, redirectUrl;

                    // if the url has parameter ref then redirect to "ref" page.
                    if ($rootScope.$previousState && $state.current.name != $rootScope.$previousState) {

                        // save the redirect state
                        var goToState = $rootScope.$previousState;
                        var prevStateParam = $rootScope.$previousStateParam;

                        // if the previous page url is dynamic we need hard refresh
                        // for instance, we cant use $state.$go without templateUrl
                        if ($rootScope.$previousIsDynamic) {
                            redirectUrl = $rootScope.$previousLocationURL;
                        }

                        // reset & clear
                        $rootScope.$previousState = null;
                        $rootScope.$previousStateParam = null;
                        $rootScope.$previousLocationURL = null;

                        if (!redirectUrl) {
                            redirectUri = $state.href(goToState, prevStateParam);
                        }

                    } else if(isTopLevel) {
                        redirectUri = $state.href("appLayout.harriSH.access-portal.main");
                    } else {
                        redirectUri = $state.href("appLayout.harriSH.dashboard");
                    }

                    var loggedUser = user.data.user || {};
                    var language = localize.getLang();

                    SettingsAPI
                        .getUserLocale()
                        .then(function (locale) {

                            redirectUrl = redirectUrl || (window.location.protocol + "//" + window.location.host + redirectUri);

                            if (locale.code !== language) {

                                language = locale.code;

                                // No need for this, Node.js side will handle the cookie update
                                HStorageManager.put({
                                    storageLevel: HStorageManager.StorageLevels.COOKIES,
                                    key: 'lang',
                                    value: language,
                                    codec: false,
                                    expiryDays: 30
                                });

                                $timeout(function () {
                                    hRedirect(hGetUrl(join_query_link(redirectUrl, {'ref': window.referer}), language));
                                }, 100);
                            }
                            else {
                                hRedirect(join_query_link(redirectUrl, {'ref': window.referer}));
                            }
                        });
                },
                isFromUK: function () {
                    var deferred = $q.defer();

                    user.getUserLocation()
                        .then(function (res) {

                            if (res) {
                                var country = (res['country'] || '').toLowerCase();
                                var countryCode = (res['countryCode'] || '').toLowerCase();
                                var timezone = (res['timezone'] || '').toLowerCase();

                                if (
                                    ['britain', 'great britain', 'united kingdom', 'england'].indexOf(country) > -1 ||
                                    ['gb', 'uk'].indexOf(countryCode) > -1 ||
                                    timezone.indexOf('europe') > -1
                                ) {
                                    deferred.resolve(true);
                                }
                                else {
                                    deferred.resolve(false);
                                }
                            }

                        }, function (err) {
                            deferred.reject(err);
                        });

                    return deferred.promise;
                },
                //@TODO: refactor & remove these lines
                setLinkAfterLoginSuccessfully: function (link) {
                    afterLoginSuccessfullyLink = link;
                },
                getLinkAfterLoginSuccessfully: function () {
                    return afterLoginSuccessfullyLink;
                },
                getUserNameReferral: function(){

                    /* check if in URL */
                    var referral = getParameterByName('r');
                    if(referral){
                        return referral;
                    }
                    //check if in cookie
                    if (HStorageManager.put({
                        storageLevel: HStorageManager.StorageLevels.COOKIES,
                        key: 'username_referral'
                    })) {
                        return HStorageManager.put({
                            storageLevel: HStorageManager.StorageLevels.COOKIES,
                            key: 'username_referral'
                        });
                    }
                },
                getHiringDashboardState: function() {
                    return user.isTTSDashboardEnabled() ? 'appLayout.harriSH.dashboard-hiring' : 'appLayout.harriSH.dashboard';
                },
                getUserMfaStatus: function(forced) {
                    var defer = $q.defer();
                    if(!forced && user.data.mfaStatus) {
                        defer.resolve(user.data.mfaStatus)
                    } else {
                        UserAPI.getUserMfaStatus()
                            .then(function(res) {
                                user.data.mfaStatus = res;
                                defer.resolve(res);
                            }, function(err) {
                                defer.resolve(err);
                            });
                    }
                    return defer.promise;
                },
                getUserBrandsIdentifier: function () {
                    var _userIdentifier;

                    if (user && user.isLoggedIn()) {
                        _userIdentifier = user.isEmployer() ? `user_${user.getUserContext().brand_id}` : 'user_';
                    } else {
                        _userIdentifier = 'guest';
                    }

                    return _userIdentifier;
                },
                getActiveBrandId: function () {
                    var userContext = user.getUserContext();
                    return userContext.active_brand_id || userContext.brand_id;
                },
            };

            _emitter = JarEventEmitter.call(user);
            //Init
            (function () {
                // Clean user cookie, no longer needed by
                // https://github.com/HarriLLC/Front-End/pull/772
                HStorageManager.remove({
                    storageLevel: HStorageManager.StorageLevels.COOKIES,
                    key: 'user'
                });

                //init the data if needed
                user.init()
                    .then(function() {
                        //If user is employer & not in top level context then load the plicies
                        user.getUserPolicy();
                    });
            })();

            return user;
        }]);
